import React from "react";
import styled from "@emotion/styled";
import { keyframes } from "@emotion/react";
import {
  ChampionsLogo,
  DarhamlaneLogo,
  DemanGeniusLogo,
  HBMLogo,
  MeridianLogo,
  NestiLogo,
  PowwowLogo,
  SalesDeskLogo,
  SeedlLogo,
} from "../../assets";

const Recommendations = ({
  title,
  logos = [
    {
      url: MeridianLogo,
      width: 173.27,
      height: 24.13,
    },
    {
      url: ChampionsLogo,
      width: 116,
      height: 30,
    },
    {
      url: SalesDeskLogo,
      width: 124,
      height: 20,
    },
    {
      url: NestiLogo,
      width: 74,
      height: 32,
    },
    {
      url: DarhamlaneLogo,
      width: 179,
      height: 22,
    },
    {
      url: SeedlLogo,
      width: 77,
      height: 24,
    },
    {
      url: DemanGeniusLogo,
      width: 159,
      height: 32,
    },

    {
      url: HBMLogo,
      width: 158,
      height: 32,
    },

    {
      url: PowwowLogo,
      width: 99,
      height: 24,
    },
  ],
  speed = 50,
  gradientBg = "#ffffff",
}) => {
  // Duplicate logos array to create seamless loop
  const duplicatedLogos = [...logos, ...logos];

  return (
    <Container>
      <TitleWrapper>
        <Title>{title}</Title>
      </TitleWrapper>
      <MarqueeWrapper>
        <MarqueeContent speed={speed}>
          {duplicatedLogos.map((logo, index) => (
            <LogoWrapper key={index}>
              <Logo
                style={{
                  backgroundImage: `url(${logo.url})`,
                  width: `${logo.width}px`,
                  height: `${logo.height}px`,
                }}
              />
            </LogoWrapper>
          ))}
        </MarqueeContent>
      </MarqueeWrapper> 
      <GradientOverlay left gradientBg={gradientBg} />
      <GradientOverlay right gradientBg={gradientBg} />
    </Container>
  );
};

const marqueeAnimation = keyframes`
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-50%);
  }
`;

const Container = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  width: 100%;
  position: relative;
  padding: 32px 0;
  overflow: hidden;
   @media (max-width: 991px) and (min-width: 768px) {
    padding:  0;
  }

  @media (max-width: 767px) {
   padding: 0;
  }
`;

const TitleWrapper = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  box-sizing: border-box;
`;

const Title = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 20px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: center;
  max-width: 1200px;
     @media (max-width: 991px) and (min-width: 768px) {
    font-size: 16px;
  }

  @media (max-width: 767px) {
    font-size: 16px;
  }
`;

const MarqueeWrapper = styled.div`
  width: 100%;
  overflow: hidden;
  position: relative;
`;

const MarqueeContent = styled.div`
  display: flex;
  gap: 48px;
  animation: ${marqueeAnimation} ${(props) => props.speed}s linear infinite;
  white-space: nowrap;
   will-change: transform;
  width: max-content;
`;

const LogoWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Logo = styled.div`
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  flex-shrink: 0;
`;

const GradientOverlay = styled.div`
  position: absolute;
  bottom: 0;
  width: 70px;
  height: 60px;
  pointer-events: none;
  background: ${(props) =>
    props.left
      ? `linear-gradient(90deg, ${props.gradientBg} 0%, rgba(255, 255, 255, 0) 100%)`
      : `linear-gradient(-90deg, ${props.gradientBg} 0%, rgba(255, 255, 255, 0) 100%)`};
  ${(props) => (props.left ? "left: 0;" : "right: 0;")}
  z-index: 1;
`;

export default Recommendations;
